/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StyleCriterion } from './StyleCriterion';
import { StyleCriterionFromJSON, StyleCriterionFromJSONTyped, StyleCriterionToJSON } from './StyleCriterion';

/**
 *
 * @export
 * @interface PaginatedStyleCriterionList
 */
export interface PaginatedStyleCriterionList {
  /**
   *
   * @type {number}
   * @memberof PaginatedStyleCriterionList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedStyleCriterionList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedStyleCriterionList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<StyleCriterion>}
   * @memberof PaginatedStyleCriterionList
   */
  results: Array<StyleCriterion>;
}

/**
 * Check if a given object implements the PaginatedStyleCriterionList interface.
 */
export function instanceOfPaginatedStyleCriterionList(value: object): value is PaginatedStyleCriterionList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedStyleCriterionListFromJSON(json: any): PaginatedStyleCriterionList {
  return PaginatedStyleCriterionListFromJSONTyped(json, false);
}

export function PaginatedStyleCriterionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedStyleCriterionList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(StyleCriterionFromJSON),
  };
}

export function PaginatedStyleCriterionListToJSON(value?: PaginatedStyleCriterionList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(StyleCriterionToJSON),
  };
}
